module.exports = __webpack_public_path__ + "majestic.5e4109cd.png";